import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  DatePicker,
  Spin,
  Typography,
  Popconfirm,
  Tag,
  Tooltip,
  Table,
  Divider,
  Tabs,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  FilePdfOutlined,
  MailOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import {
  materialDetailService,
  materialTypeService,
  stockClassificationService,
  receiptService,
  stockReceiptService,
} from "_services";
import { storageUnitService } from "_services/storageunit.service";

function Summary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [form] = Form.useForm();
  const [newLineForm] = Form.useForm();
  const [addEditStockItemForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingUpdateStocks, setLoadingUpdateStocks] = useState(false);
  const [loadingDownloadExcel, setLoadingDownloadExcel] = useState(false);
  const [loadingDownloadCsv, setLoadingDownloadCsv] = useState(false);
  const [loadingDetailsUpdate, setLoadingDetailsUpdate] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingLineItems, setLoadingLineItems] = useState(false);
  const [loadingStatusUpdate, setLoadingStatusUpdate] = useState(false);
  const [loadingNewLine, setLoadingNewLine] = useState(false);
  const [loadingAddEditStockItem, setLoadingAddEditStockItem] = useState(false);
  const [loadingLineDelete, setLoadingLineDelete] = useState(false);
  const [order, setOrder] = useState({});
  //const [orderLines, setOrderLines] = useState(null);
  const [stores, setStores] = useState([]);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [customerAddresses, setcustomerAddresses] = useState([]);
  const [stockItems, setStockItems] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [materialSuppliers, setMaterialSuppliers] = useState([]);
  const [selectedGrnLineKeys, setSelectedGrnLineKeys] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState(null);
  const [lineItemMap, setLineItemMap] = useState(new Map());
  const [customer, setCustomer] = useState(null);
  const [newLineDrawerVisible, setNewLineDrawerVisible] = useState(false);
  const [addEditStockItemDrawerVisible, setAddEditStockItemDrawerVisible] =
    useState(false);
  const [addEditMode, setAddEditMode] = useState("Add");
  const [isNewStockItems, setIsNewStockItems] = useState(false);
  const [activeLineId, setActiveLineId] = useState(null);
  const [error, setError] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const { Option } = Select;
  const { Text } = Typography;

  useEffect(() => {
    setLoading(true);
    /* companyService
      .getSuggestion("")
      .then((x) => {
        if (x.content) {
          const storeItems = x.content.filter((item) =>
            item.companyCategories.some((category) => category.code === "STO")
          );
          const customerItems = x.content.filter((item) =>
            item.companyCategories.some((category) => category.code === "CUS")
          );
          const supplierItems = x.content.filter((item) =>
            item.companyCategories.some((category) => category.code === "SUP")
          );
          setStores(storeItems);
          setcustomers(customerItems);
          setMaterialSuppliers(supplierItems);
          if (storeItems && storeItems.length === 1) {
            setLoading(true);
            companyService
              .getById(storeItems[0].id)
              .then((data) => {
                setLoading(false);
                const warehouseLocations = data.content.addresses.filter(
                  (item) => item.addressType === "WAREHOUSE"
                );
                setStoreAddresses(warehouseLocations);
                if (warehouseLocations.length === 1) {
                  form.setFieldsValue({
                    store: storeItems[0],
                    storeAddress: warehouseLocations[0],
                    uploadOption: "SUMMARY",
                  });
                }
              })
              .catch((error) => {
                setLoading(false);
              });
          }
          if (customerItems && customerItems.length === 1) {
            setLoading(true);
            companyService
              .getById(customerItems[0].id)
              .then((data) => {
                setcustomerAddresses(data.content.addresses);
              })
              .catch((error) => {
                setLoading(false);
              });
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      }); */

    // getMaterialTypes();
    // getStockClassifications();
    getStockReceipt(id);
  }, []);

  const getStockReceipt = (receiptId) => {
    setLoading(true);
    stockReceiptService
      .getViewById(receiptId)
      .then((data) => {
        setLoading(false);
        if (data) {
          let receipt = data.content;
          /* purchaseOrder.store = purchaseOrder.store.id;
          purchaseOrder.storeAddress = purchaseOrder.storeAddress.id;
          purchaseOrder.customer = purchaseOrder.customer.id;
          purchaseOrder.customerAddress = purchaseOrder.customerAddress.id; */
          receipt.receivedDate = moment(receipt.receivedDate);
          receipt.receiptLines.forEach((line, i) => {
            line.key = line.id;
          });

          setOrder(receipt);
          onFill(receipt);
          if (activeTabKey === null) {
            handleTabChange(receipt.receiptLines[0].key);
          }
        }
      })
      .catch((errorInfo) => {
        setLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getMaterialTypes = () => {
    setLoading(true);
    materialTypeService
      .getSuggestion()
      .then((x) => {
        setLoading(false);
        setMaterialTypes(x.content);
      })
      .catch((errorInfo) => {
        setLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getStockClassifications = () => {
    setLoading(true);
    stockClassificationService
      .getSuggestion()
      .then((x) => {
        setLoading(false);
        setStockClasses(x.content);
      })
      .catch((errorInfo) => {
        setLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  /* const getStoreAddresses = (companyId) => {
    addressService.getAllByCompany(companyId).then((x) => {
      setStoreAddresses(x.content);
    });
  }; */

  /* const getcustomerAddresses = (companyId) => {
    addressService.getAllByCompany(companyId).then((x) => {
      setcustomerAddresses(x.content);
    });
  }; */

  /* const getMaterialSuppliers = () => {
    supplierService
      .getSuggestion()
      .then((x) => {
        setMaterialSuppliers(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  }; */

  const handlePrintPdf = () => {
    setLoadingPdf(true);
    receiptService.printPdf(id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Stock-IN-${order.receiptNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoadingPdf(false);
    });
  };

  const handleDownloadExcelStockDetails = () => {
    setLoadingDownloadExcel(true);
    receiptService
      .downloadExcelStockDetails(id)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Barcodes_${order.preReceiptNumber}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingDownloadExcel(false);
      })
      .catch((error) => {
        setLoadingDownloadExcel(false);
        message.error(error);
      });
  };

  const handleDownloadCsvStockDetails = () => {
    setLoadingDownloadCsv(true);
    receiptService
      .downloadCsvStockDetails(id)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Update_Stock_Details_${order.preReceiptNumber}.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingDownloadCsv(false);
      })
      .catch((error) => {
        setLoadingDownloadCsv(false);
        message.error(error);
      });
  };

  const handleFormSumbit = () => {
    newLineForm
      .validateFields()
      .then((values) => {
        setLoadingNewLine(true);

        if (!values.id) {
          values.measurementType = {
            id: measurementTypes.find((item) => item.name === "Kg").id,
          };
          values.stockClass = {
            id: materialTypes.find((item) => item.id === values.stockType.id)
              .stockClass.id,
          };
          values.packingType = {
            id: materialTypes.find((item) => item.id === values.stockType.id)
              .packingType.id,
          };
          let payload = {
            id: id,
            preReceiptNumber: order.preReceiptNumber,
            actionType: "ADD_NEW_LINE",
            stockReceiptLines: [values],
          };
          // console.log("Update: ", payload);
          receiptService
            .update(id, payload)
            .then(() => {
              message.success("Successfully updated!");
              setLoadingNewLine(false);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
              window.location.reload();
            })
            .catch((error) => {
              setLoadingNewLine(false);
              setError(error);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
            });
        } else {
          receiptService
            .updateLine(id, activeTabKey, values)
            .then(() => {
              message.success("Successfully updated!");
              setLoadingNewLine(false);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
              window.location.reload();
              //history.push(`${path}`.replace(":id", id));
            })
            .catch((error) => {
              setLoadingNewLine(false);
              setError(error);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
            });
        }
      })
      .catch((errorInfo) => {});
  };

  const handleUpdateDetails = () => {
    form
      .validateFields()
      .then((values) => {
        setLoadingDetailsUpdate(true);
        const payLoad = {
          id: id,
          receiptNumber: order.receiptNumber,
          receivedDate: moment(values.receivedDate).format("YYYY-MM-DD"),
          supplier: values.supplier,
          packingStatus: values.packingStatus,
          subLocation: { id: values.subLocationId },
        };
        receiptService
          .update(id, payLoad)
          .then(() => {
            message.success("Successfully updated!");
            setLoadingDetailsUpdate(false);
            history.push(`${path}`.replace(":id", id));
          })
          .catch((error) => {
            setLoadingDetailsUpdate(false);
            setError(error);
          });
      })
      .catch((error) => {
        setError(error);
      });
  };

  const handleAddEditStockItem = () => {
    addEditStockItemForm
      .validateFields()
      .then((values) => {
        setLoadingAddEditStockItem(true);

        if (isNewStockItems) {
          let payload = {
            preReceiptLine: { id: activeLineId },
            numberOfBox: values.numberOfBox,
            packingStatus: values.packingStatus,
          };
          // console.log("Create: ", payload);
          materialDetailService
            .create(payload)
            .then(() => {
              message.success("Successfully created!");
              setLoadingAddEditStockItem(false);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
              window.location.reload();
            })
            .catch((error) => {
              setLoadingAddEditStockItem(false);
              setError(error);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
            });
        } else {
          // console.log("UPdate: ", values);
          materialDetailService
            .update(values.id, values)
            .then(() => {
              message.success("Successfully updated!");
              setLoadingAddEditStockItem(false);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
              window.location.reload();
            })
            .catch((error) => {
              setLoadingAddEditStockItem(false);
              setError(error);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
            });
        }
      })
      .catch((errorInfo) => {});
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onComplete = () => {
    setLoadingStatusUpdate(true);
    const statusUpdatePayload = {
      preReceiptNumber: order.preReceiptNumber,
      orderStage: "COMPLETE",
    };
    receiptService
      .update(id, statusUpdatePayload)
      .then(() => {
        message.success("Successfully completed!");
        setLoadingStatusUpdate(false);
        order.orderStage = "COMPLETE";
        history.push(`${path}`.replace(":id", id));
      })
      .catch((error) => {
        setLoadingStatusUpdate(false);
        setError(error);
      });
  };

  const onCancel = () => {
    history.push("/stock-receipts");
  };

  const handleStockReceipt = () => {
    history.push(`/stock-receipt/${id}`);
  };

  const handleLineEdit = (lineId) => {
    const receiptLine = order.stockReceiptLines.find(
      (line) => line.id === lineId
    );
    newLineForm.setFieldsValue(receiptLine);
    setAddEditMode("Edit");
    setNewLineDrawerVisible(true);
  };

  const handleLineDelete = (lineId) => {
    setLoadingLineDelete(true);
    receiptService
      .deleteLine(id, lineId)
      .then((x) => {
        setLoadingLineDelete(false);
        message.success("Successfully line deleted!");
        window.location.reload();
      })
      .catch((error) => {
        setLoadingLineDelete(false);
        setError(error);
      });
  };

  const handleStockItemEdit = (stockItemId) => {
    const stock = lineItemMap
      .get(activeTabKey)
      .find((item) => item.id === stockItemId);
    addEditStockItemForm.setFieldsValue(stock);
    setIsNewStockItems(false);
    setAddEditMode("Edit");
    setAddEditStockItemDrawerVisible(true);
  };

  const handleStockItemDelete = (stockItemId) => {
    materialDetailService
      .delete(stockItemId)
      .then((x) => {
        message.success("Successfully deleted!");
        window.location.reload();
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const handleStockItemFormSumbit = () => {
    const payload = {
      stockItems: stockItems
        .filter((item) => item.quantity || item.netWeight || item.grossWeight)
        .map((item) => ({
          id: item.id,
          quantity: item.quantity,
          netWeight: item.netWeight,
          grossWeight: item.grossWeight,
        })),
    };
    setLoadingUpdateStocks(true);
    //console.log("PL: ", payload);
    materialDetailService
      .bulkUpdate(payload)
      .then((data) => {
        message.success("Successfully updated the stock item details.");
        setLoadingUpdateStocks(false);
      })
      .catch((error) => {
        setLoadingUpdateStocks(false);
        message.error(error);
      });
  };

  const showNewLineDrawer = () => {
    setAddEditMode("Add");
    setNewLineDrawerVisible(true);
  };

  const onCloseNewLineDrawer = () => {
    if (!loadingNewLine) {
      newLineForm.resetFields();
      setNewLineDrawerVisible(false);
    }
  };

  const showAddNewStockItemDrawer = (receiptLineId) => {
    const receiptLine = order.stockReceiptLines.find(
      (line) => line.id === receiptLineId
    );
    addEditStockItemForm.setFieldsValue(receiptLine);
    setActiveLineId(receiptLineId);
    setIsNewStockItems(true);
    setAddEditMode("Add");
    setAddEditStockItemDrawerVisible(true);
  };

  const onCloseAddEditStockItemDrawer = () => {
    if (!loadingAddEditStockItem) {
      addEditStockItemForm.resetFields();
      setAddEditStockItemDrawerVisible(false);
    }
  };

  const handleStatusUpdate = () => {
    let newStatus = order.orderStage;
    if (order.orderStage === "OPEN") {
      newStatus = "UPDATE";
    } else if (order.orderStage === "UPDATE") {
      newStatus = "COMPLETE";
    }
    const statusUpdatePayload = {
      receiptStatus: newStatus,
    };
    setLoadingStatusUpdate(true);
    receiptService
      .updateStatus(id, statusUpdatePayload)
      .then(() => {
        message.success("Successfully status changed!");
        setLoadingStatusUpdate(false);
        window.location.reload();
        /* if (newStatus === "COMPLETE") {
          setLoadingStatusUpdate(true);
          stockReceiptService
            .sendMail(id)
            .then(() => {
              message.success("Email sent successfully!");
              setLoadingStatusUpdate(false);
              window.location.reload();
            })
            .catch((error) => {
              setLoadingStatusUpdate(false);
              setError(error);
            });
        } else {
          window.location.reload();
        } */
      })
      .catch((error) => {
        setLoadingStatusUpdate(false);
        setError(error);
      });
  };

  const handleSendEmail = () => {
    setLoadingStatusUpdate(true);
    receiptService
      .sendMail(id)
      .then(() => {
        message.success("Email sent successfully!");
        setLoadingStatusUpdate(false);
        window.location.reload();
      })
      .catch((error) => {
        setLoadingStatusUpdate(false);
        setError(error);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    if (order.orderStage !== "COMPLETE") {
      let statusButtonText = "";
      if (order.orderStage === "OPEN") {
        statusButtonText = "Start Update";
      } else if (order.orderStage === "UPDATE") {
        statusButtonText = "Complete";
      }
      buttons.push(
        <Popconfirm
          title={`Are you sure to ${statusButtonText} it?`}
          onConfirm={(e) => {
            e.preventDefault();
            handleStatusUpdate();
          }}
          key="con-complete"
          //disabled={addedStocks.length === 0}
        >
          <Button
            key="btn-complete"
            htmlType="button"
            type="primary"
            loading={loadingStatusUpdate}
          >
            {statusButtonText}
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button
        key="pdf"
        icon={<FilePdfOutlined />}
        onClick={handlePrintPdf}
        loading={loadingPdf}
      ></Button>
    );
    buttons.push(
      <Button
        key="mail"
        icon={<MailOutlined />}
        onClick={handleSendEmail}
        loading={loadingStatusUpdate}
      ></Button>
    );
    /* buttons.push(
      <Tooltip
        key="tp-download-details"
        placeholder="topLeft"
        title="Download Stock Details"
      >
        <Button
          key="btn-download-details"
          icon={<DownloadOutlined />}
          onClick={handleDownloadCsvStockDetails}
          loading={loadingDownloadCsv}
        ></Button>
      </Tooltip>
    ); */
    /* buttons.push(
      <Tooltip
        key="tp-download-full-details"
        placeholder="topLeft"
        title="Download Barcode Details"
      >
        <Button
          key="barcode"
          icon={<BarcodeOutlined />}
          onClick={handleDownloadExcelStockDetails}
          loading={loadingDownloadExcel}
        ></Button>
      </Tooltip>
    ); */
    if (["UPDATE"].includes(order.orderStage)) {
      buttons.push(
        <Tooltip key="tp-update" placeholder="topLeft" title="Update Details">
          <Button
            key="update"
            icon={<CheckOutlined />}
            onClick={handleUpdateDetails}
            loading={loadingDetailsUpdate}
          ></Button>
        </Tooltip>
      );
      buttons.push(
        <Tooltip
          key="tp-upload-details"
          placeholder="topLeft"
          title="Upload Stock Details"
        >
          <Button
            key="btn-upload-details"
            icon={<UploadOutlined />}
            href={`/material-details/update-via-upload/${id}`}
            target="_blank"
          ></Button>
        </Tooltip>
      );
    }
    /* buttons.push(
      <Tooltip key="tp-update" placeholder="topLeft" title="Update Details">
        <Button
          key="update"
          icon={<CheckOutlined />}
          onClick={handleUpdateDetails}
          loading={loadingDetailsUpdate}
        ></Button>
      </Tooltip>
    ); */
    /* if (order.orderStage !== "COMPLETE") {
      buttons.push(
        <Popconfirm
          title="Are you sure to complete it?"
          onConfirm={onComplete}
          key="con-complete"
          //disabled={addedStocks.length === 0}
        >
          <Button
            key="btn-complete"
            htmlType="button"
            loading={loadingStatusUpdate}
          >
            Complete
          </Button>
        </Popconfirm>
      );
    } */
    buttons.push(
      <Button key="btn-cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Material",
      dataIndex: "stockTypeCode",
      key: "stockTypeCode",
      //width: "15%",
      /* render: (text, record) => {
        return record.stockType.code;
      }, */
    });
    columns.push({
      title: "Description",
      dataIndex: "stockTypeName",
      key: "stockTypeName",
      //width: "15%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockTypeName}>
            {record.stockTypeName}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Packing Type",
      dataIndex: "receivedPackingTypeName",
      key: "packingType",
      //render: (text, record) => record.packingType?.name,
    });
    columns.push({
      title: "Rec’d. Pallets",
      dataIndex: "receivedStorageUnits",
      key: "receivedStorageUnits",
      align: "right",
    });
    /* columns.push({
      title: 'Inv. Net.W',
      dataIndex: 'netWeight',
      key: 'netWeight',
      align: 'right',
      render: (text, record) => {
        return !isNaN(text) && Number(text).toFixed(2);
      },
    }); */
    /* columns.push({
      title: 'Inv. Gross.W',
      dataIndex: 'grossWeight',
      key: 'grossWeight',
      align: 'right',
      render: (text, record) => {
        return !isNaN(text) && Number(text).toFixed(2);
      },
    }); */
    columns.push({
      title: "Rec’d. Qty",
      dataIndex: "receivedPackages",
      key: "receivedPackages",
      align: "right",
    });
    /* columns.push({
      title: 'Rec’d. Net.W',
      dataIndex: 'receivedNetWeight',
      key: 'receivedNetWeight',
      align: 'right',
      render: (text, record) => {
        return !isNaN(text) && Number(text).toFixed(2);
      },
    }); */
    /* columns.push({
      title: 'Rec’d. Gross.W',
      dataIndex: 'receivedGrossWeight',
      key: 'receivedGrossWeight',
      align: 'right',
      render: (text, record) => {
        return !isNaN(text) && Number(text).toFixed(2);
      },
    }); */
    /* columns.push({
      title: "Diff Qty",
      key: "diffNetWeight",
      align: "right",
      render: (text, record) => {
        return (
          <b>{Number(record.receivedQuantity - record.quantity).toFixed(0)}</b>
        );
      },
    }); */
    columns.push({
      title: "Purchase Order Number",
      dataIndex: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
      align: "right",
      render: (text, record) => (
        <Link to={`/purchase-orders/${record.purchaseOrderId}/receipt-details`}>{text}</Link>
      ),
    });

    columns.push({
      title: "",
      key: "action",
      //width: "6%",
      render: (text, record) => {
        return (
          <span>
            {["OPEN"].includes(record.lineStage) && (
              <Button
                icon={<EditOutlined />}
                title="Edit"
                type="link"
                style={{ marginRight: 10 }}
                onClick={() => handleLineEdit(record.id)}
              ></Button>
            )}
            {["OPEN"].includes(record.lineStage) && (
              <Popconfirm
                title="Are you sure to delete this line?"
                onConfirm={() => handleLineDelete(record.id)}
              >
                <CloseOutlined
                  loading={loadingLineDelete && record.key === activeTabKey}
                />
              </Popconfirm>
            )}
          </span>
        );
      },
    });

    return columns;
  };

  const getStockItemColumns = () => {
    let columns = [];
    columns.push({
      title: "Material",
      dataIndex: "stockTypeCode",
      key: "stockTypeCode",
      render: (text, record) => {
        return record.stockTypeCode;
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      dataIndex: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockTypeName}>
            {record.stockTypeName}
          </Tooltip>
        );
      },
    });
    /* columns.push({
      title: "Serial Number",
      dataIndex: "serialNo",
      key: "serialNo",
      width: "12%",
    }); */
    /* columns.push({
      title: "Prod Date",
      dataIndex: "productionDate",
      key: "productionDate",
      width: "8%",
    }); */
    columns.push({
      title: "Recv Date",
      dataIndex: "receivedDate",
      key: "receivedDate",
      //width: "8%",
    });
    columns.push({
      title: "Bin",
      dataIndex: "stockBinCode",
      key: "stockBin",
      render: (text, record) => {
        return record.stockBinCode;
      },
    });
    columns.push({
      title: "Pallet No:",
      dataIndex: "palletNo",
      key: "palletNo",
      align: "right",
    });
    columns.push({
      title: "Quantity",
      dataIndex: "totalItems",
      key: "totalItems",
      align: "right",
      //width: "5%",
    });
    /* columns.push({
      title: 'B/No',
      dataIndex: 'tempNumber',
      key: 'tempNumber',
      width: '4%',
    }); */
    /* columns.push({
      title: 'Cone',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      width: '5%',
    }); */
    /* columns.push({
      title: 'Net Weight',
      dataIndex: 'netWeight',
      key: 'netWeight',
      align: 'right',
      width: '7%',
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
    }); */
    /* columns.push({
      title: "Gross Weight",
      dataIndex: "grossWeight",
      key: "grossWeight",
      align: "right",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
    }); */
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      //width: "7%",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        if (text === "LOADED") {
          color = "#87d068";
        }
        if (text === "READY") {
          color = "#87d068";
        }
        if (text === "PENDING") {
          color = "#2db7f5";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    if (order.orderStage !== "COMPLETE") {
      columns.push({
        title: "",
        key: "action",
        render: (text, record) => {
          return (
            <span>
              {["AVAILABLE", "REQUESTED", "READY"].includes(record.mode) && (
                <Button
                  icon={<EditOutlined />}
                  title="Edit"
                  type="link"
                  style={{ marginRight: 10 }}
                  onClick={() => handleStockItemEdit(record.id)}
                ></Button>
              )}
              {["AVAILABLE", "REQUESTED", "READY"].includes(record.mode) && (
                <Popconfirm
                  title="Are you sure to delete this item?"
                  onConfirm={() => handleStockItemDelete(record.id)}
                >
                  <CloseOutlined />
                </Popconfirm>
              )}
            </span>
          );
        },
      });
    }

    return columns;
  };

  const grnLineRowSelection = {
    selectedRowKeys: selectedGrnLineKeys,
    onChange: (selectedGrnLineKeys) => {
      handleTabChange(selectedGrnLineKeys[0]);
    },
  };

  const getLineStorageUnits = (receiptLineId) => {
    setLoadingLineItems(true);
    let searchParams = `?encryptedReceiptLineId=${receiptLineId}`;
    storageUnitService
      .search(searchParams)
      .then((result) => {
        setLineItemMap(lineItemMap.set(receiptLineId, result.content));
        setLoadingLineItems(false);
      })
      .catch(() => {
        setLoadingLineItems(false);
      });

    /* stockReceiptService
      .getSuggestionNew(id, paginationParams)
      .then((result) => {
        setLineItemMap(lineItemMap.set(id, result.content));
        setTotalRecords(result.pagination.totalRecords);
        setPageNumber(result.pagination.pageNumber);
        setPageSize(result.pagination.pageSize);
        setLoadingLineItems(false);
      })
      .catch(() => {
        setLoadingLineItems(false);
      }); */
  };

  const handleTabChange = (activeKey) => {
    setActiveTabKey(activeKey.toString());
    setSelectedGrnLineKeys([activeKey.toString()]);
    if (!lineItemMap.get(activeKey)) {
      getLineStorageUnits(activeKey);
      //getLineMaterialSuggestions(activeKey, pageNumber, pageSize);
      /* materialDetailService
        .getSuggestion(`?purchaseOrderLineId=${activeKey}`)
        .then((result) => {
          setLineItemMap(lineItemMap.set(activeKey, result.content));
          setLoadingLineItems(false);
        })
        .catch(() => {
          setLoadingLineItems(false);
        }); */
    }
  };

  /* const handlePaginateChange = (page, pagesize) => {
    setLoadingLineItems(true);
    getLineMaterialSuggestions(activeTabKey, page, pagesize);
  }; */

  const getTabContent = (grnLines) => {
    let tabPanes = [];
    grnLines.forEach((line, index) => {
      tabPanes.push(
        <Tabs.TabPane
          tab={`${line.stockTypeCode} (${line.receivedStorageUnits})`}
          key={line.id}
        >
          <Spin tip="Loading..." spinning={loadingLineItems}>
            {lineItemMap.get(line.id) && (
              <Table
                bordered
                size="small"
                rowKey="id"
                columns={getStockItemColumns()}
                dataSource={lineItemMap.get(line.id)}
                pagination={false}
                /* pagination={{
                  current: pageNumber,
                  pageSize: pageSize,
                  total: totalRecords,
                  showTotal: (total) => `Total ${total} items`,
                  pageSizeOptions: [10, 20, 50, 100, 200],
                  showSizeChanger: true,
                  onChange: (page, pageSize) =>
                    handlePaginateChange(page, pageSize),
                }} */
                summary={(pageData) => {
                  let totalStorageUnits = 0;
                  let totalPackages = 0;
                  let totalInnerItems = 0;

                  pageData.forEach(({ totalItems, quantity }) => {
                    totalStorageUnits += 1;
                    totalPackages += totalItems;
                  });

                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell
                          colSpan={
                            getStockItemColumns().length - order.orderStage !==
                            "COMPLETE"
                              ? 4
                              : 3
                          }
                        >
                          <Text strong>Total</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell align="right">
                          <Text strong style={{ paddingLeft: 12 }}>
                            {totalStorageUnits}
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell align="right">
                          <Text strong style={{ paddingLeft: 12 }}>
                            {totalPackages}
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell
                          colSpan={order.orderStage !== "COMPLETE" ? 2 : 1}
                        />
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            )}
            {/* order.orderStage === "UPDATE" && (
              <Button
                style={{
                  width: "100%",
                  marginTop: 16,
                  marginBottom: 8,
                  background: "rgb(190, 200, 200)",
                }}
                type="dashed"
                onClick={() => showAddNewStockItemDrawer(line.id)}
                icon={<PlusOutlined />}
              >
                Add Stock Item/s
              </Button>
            ) */}
          </Spin>
        </Tabs.TabPane>
      );
    });

    return tabPanes;
  };

  const getLineRowColor = (record) => {
    let rowColor = "";
    if (record && record.lineStatus === "OPEN") {
      rowColor = "";
    } else if (record && record.lineStatus === "VERIFIED") {
      rowColor = "";
    } else if (record && record.lineStatus === "COMPLETE") {
      rowColor = "ant-tag-green";
    }

    return rowColor;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Stock Receipt Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`.replace(":id", id)}>
                {order.receiptNumber} ::{" "}
                <Tag
                  color={`${
                    order.orderStage === "OPEN"
                      ? "#2db7f5"
                      : order.orderStage === "UPDATE"
                      ? "#108ee9"
                      : "#87d068"
                  }`}
                >
                  {order.orderStage}
                </Tag>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <TabMenu menu="summary" id={id} status={order.orderStage} />
          <Spin tip="Loading..." spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="supplierName"
                    label="Supplier"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="storeName"
                    label={<Text strong>Store</Text>}
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="receivedDate"
                    label="Received Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder="Received Date"
                      style={{ width: "100%" }}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="receiptNumber"
                    label="Receipt Number"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="customerAddress"
                    label="Deliver From"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="storeAddress"
                    label="Delivery To"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
                <Col span={6}>
                  <Form.Item
                    name="stockClassification"
                    label="Stock Category"
                    rules={[
                      { required: true, message: "Stock category is required" },
                    ]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
              </Row>
              {order && order.receiptLines && order.receiptLines.length > 0 && (
                <>
                  <Row gutter={24}>
                    <Table
                      bordered
                      pagination={false}
                      columns={getLineColumns()}
                      dataSource={order.receiptLines}
                      rowSelection={{
                        type: "radio",
                        ...grnLineRowSelection,
                      }}
                      rowClassName={(record) => getLineRowColor(record)}
                      size="small"
                      summary={(pageData) => {
                        let totalReceivedStorageUnits = 0;
                        let totalReceivedPackages = 0;

                        pageData.forEach(
                          ({ receivedStorageUnits, receivedPackages }) => {
                            totalReceivedStorageUnits += receivedStorageUnits;
                            totalReceivedPackages += receivedPackages;
                          }
                        );

                        return (
                          <>
                            <Table.Summary.Row>
                              <Table.Summary.Cell colSpan={4}>
                                <Text strong>Total</Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell align="right">
                                <Text strong>{order.receivedStorageUnits}</Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell align="right">
                                <Text strong>{totalReceivedPackages}</Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell />
                            </Table.Summary.Row>
                          </>
                        );
                      }}
                    />
                  </Row>
                  {/* <Button
                    style={{
                      width: "100%",
                      marginTop: 16,
                      marginBottom: 8,
                      background: "rgb(190, 200, 200)",
                    }}
                    type="dashed"
                    onClick={showNewLineDrawer}
                    icon={<PlusOutlined />}
                  >
                    Add New Line
                  </Button> */}
                  <Divider orientation="left">Stock Items</Divider>
                  <Tabs
                    onChange={handleTabChange}
                    activeKey={activeTabKey}
                    type="card"
                  >
                    {getTabContent(order.receiptLines)}
                  </Tabs>
                </>
              )}
            </Form>
          </Spin>
          {/* <Drawer
            title={`${addEditMode} Receipt Line`}
            width={360}
            onClose={onCloseNewLineDrawer}
            visible={newLineDrawerVisible}
            bodyStyle={{ paddingBottom: 80 }}
          >
            <Form
              name="new-line"
              layout="vertical"
              hideRequiredMark
              form={newLineForm}
            >
              <Form.Item hidden name="id">
                <Input type="hidden" />
              </Form.Item>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name={["stockType", "id"]}
                    label="Material"
                    rules={[
                      { required: true, message: "Please select material" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {materialTypes.length > 0 &&
                        materialTypes.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.code}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="quantity"
                    label="# of Packages"
                    rules={[
                      {
                        required: true,
                        message: "Please enter total packages",
                      },
                    ]}
                  >
                    <InputNumber placeholder="# of Packages" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <div
              style={{
                position: "absolute",
                right: 0,
                bottom: 0,
                width: "100%",
                borderTop: "1px solid #e9e9e9",
                padding: "10px 16px",
                background: "#fff",
                textAlign: "right",
              }}
            >
              <Button onClick={onCloseNewLineDrawer} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button
                onClick={handleFormSumbit}
                type="primary"
                loading={loadingNewLine}
              >
                Submit
              </Button>
            </div>
          </Drawer> */}
          {/* <Drawer
            title={`${addEditMode} Stock Item`}
            width={360}
            onClose={onCloseAddEditStockItemDrawer}
            visible={addEditStockItemDrawerVisible}
            bodyStyle={{ paddingBottom: 80 }}
          >
            <Form
              name="addEdit-stock"
              layout="vertical"
              hideRequiredMark
              form={addEditStockItemForm}
            >
              <Form.Item hidden name="id">
                <Input type="hidden" />
              </Form.Item>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name={["stockType", "id"]}
                    label="Material"
                    rules={[
                      { required: true, message: "Please select material" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      disabled
                    >
                      {materialTypes.length > 0 &&
                        materialTypes.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.code}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  {isNewStockItems && (
                    <Form.Item name="quantity" label="Invoiced Box">
                      <InputNumber placeholder="Box" disabled />
                    </Form.Item>
                  )}
                  {!isNewStockItems && (
                    <Form.Item name="productionDate" label="Production Date">
                      <Input placeholder="Production Date" />
                    </Form.Item>
                  )}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  {isNewStockItems && (
                    <Form.Item name="receivedQuantity" label="Received Box">
                      <InputNumber placeholder="Box" disabled />
                    </Form.Item>
                  )}
                  {!isNewStockItems && (
                    <Form.Item
                      name="quantity"
                      label="Cone"
                      rules={[
                        {
                          required: true,
                          message: "Please enter valid code quantity",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Cone" />
                    </Form.Item>
                  )}
                </Col>
              </Row>
              {isNewStockItems && (
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      name="numberOfBox"
                      label="Number of Packages"
                      rules={[
                        {
                          required: true,
                          message: "Please enter # of packages",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Number of Packages" min={1} />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Form>
            <div
              style={{
                position: "absolute",
                right: 0,
                bottom: 0,
                width: "100%",
                borderTop: "1px solid #e9e9e9",
                padding: "10px 16px",
                background: "#fff",
                textAlign: "right",
              }}
            >
              <Button
                onClick={onCloseAddEditStockItemDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleAddEditStockItem}
                type="primary"
                loading={loadingAddEditStockItem}
              >
                Submit
              </Button>
            </div>
          </Drawer> */}
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
